import React from 'react';
import { Button } from '@3plearning/react-components';
import { t } from '@lingui/macro';
import { localeCode } from '../../../helpers/locale-helpers';
import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';
import { DATE_RANGE_OPTIONS } from '../../report-filters/filter-constants';
import modalActions from '../../../containers/modal-container/modal-actions';
import DownloadPicker from './download-picker';
import Resources from '../../../helpers/resources';
import UIHelper from '../../../helpers/ui-helper';
import { REPORT_EXPORTED } from '../export-report/export-report-actions';
import busyIndicatorActions from '../../../components/busy-indicator/busy-indicator-actions';
import { MATHLETICS_ID } from '../../../helpers/constants';

export const UPDATE_REPORT_SELECTION = 'UPDATE_REPORT_SELECTION';
export const DOWNLOAD_REQUESTED = 'DOWNLOAD_REQUESTED';
export const DOWNLOAD_COMPLETED = 'DOWNLOAD_COMPLETED';
export const RESET_REPORT_SELECTION = 'RESET_REPORT_SELECTION';

const downloadRequested = () => ({
    type: DOWNLOAD_REQUESTED
});

const downloadCompleted = () => ({
    type: DOWNLOAD_COMPLETED
});

const getModalContent = (dispatch, getState) => {
    const i18n = window.i18n;
    const modalBtnDisabled = getState().downloadReport.reportTypes.length === 0;
    const text = {
        titleText: i18n._(
            t(
                'Download Report - Download Student Reports'
            )`Download Student Reports`
        ),
        cancelText: i18n._(t('Download Report - Cancel')`Cancel`),
        exportText: i18n._(t('Download Report - Export')`Export`)
    };

    return {
        title: text.titleText,
        content: <DownloadPicker />,
        buttons: [
            { text: text.cancelText, danger: true },
            {
                text: text.exportText,
                primary: true,
                disabled: modalBtnDisabled,
                type: Button.LOZENGE,
                handler: () => {
                    studentReportDownload(dispatch, getState);
                }
            }
        ]
    };
};

export const updateReportSelection = (reportTypes) => (dispatch, getState) => {
    dispatch({
        type: UPDATE_REPORT_SELECTION,
        reportTypes
    });
    dispatch(modalActions.updateModal(getModalContent(dispatch, getState)));
};

export const resetReportSelections = () => (dispatch) => {
    dispatch({
        type: RESET_REPORT_SELECTION
    });
};

export default function downloadAction() {
    return (dispatch, getState) => {
        dispatch(modalActions.openModal(getModalContent(dispatch, getState)));
    };
}

export function studentReportDownload(dispatch, getState) {
    const state = getState();
    const classroomId = activeFiltersSelectors.selectClassId(state);
    const selectedDate = activeFiltersSelectors.selectDate(state);
    const dateRange = DATE_RANGE_OPTIONS[selectedDate.type];
    const assignmentResultType = state.assignmentResultType;
    const locale = localeCode();

    const request = {
        reportTypes: state.downloadReport.reportTypes,
        productId: MATHLETICS_ID,
        dateRange,
        upfReportAssignmentResultType: assignmentResultType
    };

    request.startDate = selectedDate.startDate;
    request.endDate = selectedDate.endDate;

    Resources.generateDownloadReport
        .post({ classroomId })
        .withBody(request)
        .withParams({ locale })
        .send()
        .then((payload) => {
            dispatch(downloadCompleted());
            if (payload.valid) {
                const { reportDate, downloadKey } = payload.data;

                if (downloadKey) {
                    const paramIdx = payload.verb.url.indexOf('?');
                    if (paramIdx !== -1) {
                        payload.verb.url = payload.verb.url.substring(
                            0,
                            paramIdx
                        );
                    }
                    const { startDate } = UIHelper.formatDate({
                        startDate: reportDate,
                        endDate: reportDate
                    });
                    const reportDateFormatted = startDate.replace(/\s/g, '');
                    dispatch({
                        type: REPORT_EXPORTED,
                        payload: {
                            downloadUrl: encodeURI(
                                `${payload.verb.url}/${downloadKey}/${reportDateFormatted}`
                            )
                        }
                    });
                }
            }
        });

    dispatch(modalActions.closeModal());
    dispatch(busyIndicatorActions.hideBusy());
    dispatch(downloadRequested());
}



// WEBPACK FOOTER //
// ./components/sub-heading/download-report/download-report-actions.js